<campus-maintenance-mode
  *ngIf="isMaintenanceMode$ | async; else operationalMode"
  [statusPageUrl]="statusPageUrl"
></campus-maintenance-mode>

<ng-template #operationalMode>
  <!-- Student registration form -->
  <div class="[ relative container container-max-width-3vxl stack ]">
    <h1 class="[ headline-large text-center ]" data-cy="form-header">Registreer als leerling</h1>

    <dcr-animated-kai
      #kai
      src="assets/rive/kai_state_machine.riv"
      autoplay
      track-lookat
      react-to-click
      class="[ kai ][ absolute inset-is-0 inset-bs-0 transform -translate-x-2/3 w-3xs ]"
    ></dcr-animated-kai>

    <div class="[ stack flex-1 ]">
      <polpo-register-form (register)="register($event)" [error]="registrationError$ | async"></polpo-register-form>
    </div>
  </div>
</ng-template>
